export default "__VITE_ASSET__DkUzuw1n__"